const ru = {
	'快跟我一起来<br />SuperChinese学中文吧!': 'Изучайте китайский <br />со мной в программа SuperChinese',
	'零基础任性学': 'Изучайте с нуля',
	'听说读写全面提升': 'Повысить способность по всем стороннам',
	'趣味对话': 'Интересные диалоги',
	'100+日常对话等你来': 'Более 100 этапов по повседневным темам разговора.',
	'智能AI': 'Интеллегентная AI-программа',
	'个性化学习推荐，由浅入深系统学': 'Личные рекомендования и систематический план изучения.',
	'趣味对话等你来': 'Интересные диалоги',
	'立即打开': 'Открыть прямо сейчас',
	'我在SuperChinese<br />已累计学习{day}天': 'Я в программе SuperChinese Вы уже наперерывно изучали на <span>{day}</span> дней',
	'我在SuperChinese<br />已连续学习{day}天': 'Я в программе SuperChinese Вы уже неперерывно изучали на <span>{day}</span> дней.',
	'学习生词': 'Узнать о новых словах',
	'学习语法': 'Изучать грамматику',
	'口语练习': 'Разговорные упражнения',
	'{n}个': '<span>{n}</span>штуки',
	'{n}次': '<span>{n}</span>раз',
	'点击右上角的按钮,选择在浏览器中打开': 'Нажмите на кнопку в правом верхнем углу,Выберите, чтобы открыть в браузере',
	'邀请码': 'Код приглашения',
	'用邀请码注册，参与抽大奖': 'Пригласите новых пользователей зарегистрироваться и заполнить код приглашения для участия в лотерее.',
}
export default ru;